import * as actions from '../actions/user-change-log-collection';

import * as _ from 'lodash';
import { SortDescriptor } from '@progress/kendo-data-query';
import { ChangeLogItem } from '../../domain/models';

export interface State {
  isLoadingMap: Map<number, boolean>;
  itemsMap: Map<number, Array<ChangeLogItem>>;
}

const initialState: State = {
  isLoadingMap: new Map(),
  itemsMap: new Map(),
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      const isLoadingMap = _.cloneDeep(state.isLoadingMap);
      isLoadingMap.set(action.payload.userId, true);
      return {
        ...state,
        isLoadingMap
      };
    }

    case actions.LOAD_SUCCESS: {
      const itemsMap = _.cloneDeep(state.itemsMap);
      itemsMap.set(action.payload.userId, action.payload.items);
      const isLoadingMap = _.cloneDeep(state.isLoadingMap);
      isLoadingMap.set(action.payload.userId, false);
      return {
        ...state,
        isLoadingMap,
        itemsMap,
      };
    }

    case actions.LOAD_FAIL: {
      const isLoadingMap = _.cloneDeep(state.isLoadingMap);
      isLoadingMap.set(action.payload, false);
      return {
        ...state,
        isLoadingMap,
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoadingMap = (state: State) => state.isLoadingMap;
export const getItemsMap = (state: State) => state.itemsMap;
